import { render } from "./ProgressBarStats.vue?vue&type=template&id=5fe5f658&scoped=true"
import script from "./ProgressBarStats.vue?vue&type=script&lang=js"
export * from "./ProgressBarStats.vue?vue&type=script&lang=js"

import "./ProgressBarStats.vue?vue&type=style&index=0&id=5fe5f658&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe5f658"]])

export default __exports__